import { useState } from 'react'
import { byId } from '../data/catalog'
import { GUARANTEE_THRESHOLD } from '../domain/economy'
import { useAppStore } from '../store'
import { DecorVector, FishVector, PlantVector } from './Aquarium'
import { Icon } from './Icons'

export function ItemPreview({ itemId }: { itemId: string }) {
  const item = byId.get(itemId)
  if (!item) return null
  if (item.category === 'fish') return <FishVector item={item} stage={1} />
  if (item.category === 'plant') return <PlantVector item={item} />
  if (item.category === 'decor') return <DecorVector item={item} />
  return <div className="background-swatch" style={{ background: `linear-gradient(${item.colors.join(',')})` }} />
}

export function DiscoveryModal({ onClose }: { onClose: () => void }) {
  const { state, lastDraw, spin, clearDraw } = useAppStore()
  const [spinning, setSpinning] = useState(false)

  const performSpin = () => {
    if (!state.tickets || spinning) return
    setSpinning(true)
    window.setTimeout(() => {
      spin()
      setSpinning(false)
    }, state.settings.reducedMotion ? 200 : 1700)
  }

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true" aria-label="Discovery Wheel">
      <section className="modal-card discovery-card">
        <button className="icon-button modal-close" aria-label="Close Discovery Wheel" onClick={() => { clearDraw(); onClose() }}><Icon name="close" /></button>
        {lastDraw ? (
          <div className="reward-reveal">
            <p className="eyebrow">{lastDraw.duplicate ? 'A familiar discovery' : 'New discovery'}</p>
            <div className="reward-orb"><ItemPreview itemId={lastDraw.item.id} /></div>
            <h2>{lastDraw.item.name}</h2>
            <p>{lastDraw.item.description}</p>
            {lastDraw.duplicate ? <p className="reward-conversion">Already owned — converted to {lastDraw.conversionFeed} feed.</p> : <p className="reward-conversion">Added permanently to your collection.</p>}
            <button className="primary" onClick={() => clearDraw()}>Continue</button>
          </div>
        ) : (
          <>
            <p className="eyebrow">Focus-earned discovery</p>
            <h2>Discovery Shell</h2>
            <p>Every ticket was earned through focused time. Tickets are never sold.</p>
            <div className={`wheel ${spinning ? 'spinning' : ''}`} aria-label="Reward categories: decoration 35%, plants 30%, fish 25%, special 10%">
              <span>Fish</span><span>Plants</span><span>Decor</span><span>Special</span>
              <div className="wheel-center"><Icon name="sparkle" /></div>
            </div>
            <div className="chance-grid">
              <span><b>35%</b> Decor</span><span><b>30%</b> Plants</span><span><b>25%</b> Fish</span><span><b>10%</b> Special</span>
            </div>
            <div className="guarantee-line"><span>New-item guarantee</span><strong>{state.guarantee}/{GUARANTEE_THRESHOLD}</strong></div>
            <button className="primary wide" disabled={!state.tickets || spinning} onClick={performSpin}>
              <Icon name="ticket" /> {spinning ? 'Discovering…' : state.tickets ? `Use 1 ticket · ${state.tickets} saved` : 'Earn a ticket through focus'}
            </button>
          </>
        )}
      </section>
    </div>
  )
}
